import { CABIN_UPGRADE } from '../products';
import { getPrice } from '../single-choice/utils/selection';
import { getGraphQlSelection } from './utils/getGraphQlSelection';
import { isUpgradeSaved } from './utils/utils';
import CabinUpgrade from './containers/CabinUpgradeContainer';
const {
  id,
  name: formSection
} = CABIN_UPGRADE;
const getSelected = (name, form) => state => isUpgradeSaved(form, name, state);
export const cabinUpgrade = {
  formSection,
  getPrice: getPrice.bind(null, formSection),
  getSelected: getSelected.bind(null, formSection),
  getGraphQlSelection: getGraphQlSelection(String(id), formSection),
  ...CABIN_UPGRADE
};
export default CabinUpgrade;
//# sourceMappingURL=index.js.map